import consumer from "./consumer"

/**
 * Module singleton pour gérer une seule connexion Action Cable
 * pour toutes les cabines sur la page operational_status.
 * 
 * Utilisation :
 *   import OperationalStatusChannel from "channels/operational_status_channel"
 *   
 *   // S'abonner aux updates d'une cabine
 *   OperationalStatusChannel.subscribe(cabineId, callback)
 *   
 *   // Se désabonner
 *   OperationalStatusChannel.unsubscribe(cabineId)
 *   
 *   // Envoyer une commande
 *   OperationalStatusChannel.sendCommand(cabineId, command, payload)
 */

class OperationalStatusChannelManager {
  constructor() {
    this.subscription = null
    this.subscribers = new Map() // cabineId -> callback
    this.connected = false
  }

  /**
   * S'abonner aux mises à jour d'une cabine
   * @param {number} cabineId - ID de la cabine
   * @param {function} callback - Fonction appelée avec les données reçues
   */
  subscribe(cabineId, callback) {
    // Normaliser l'ID en nombre pour la cohérence
    const normalizedId = Number(cabineId)
    console.log('[OperationalStatusChannel] subscribe() appelé pour cabine', normalizedId)
    
    // Créer la connexion si elle n'existe pas
    if (!this.subscription) {
      console.log('[OperationalStatusChannel] Création de la subscription...')
      this._createSubscription()
    }

    // Enregistrer le callback
    this.subscribers.set(normalizedId, callback)
    console.log('[OperationalStatusChannel] Subscribers après ajout:', [...this.subscribers.keys()])
  }

  /**
   * Se désabonner des mises à jour d'une cabine
   * @param {number} cabineId - ID de la cabine
   */
  unsubscribe(cabineId) {
    const normalizedId = Number(cabineId)
    this.subscribers.delete(normalizedId)

    // Si plus personne n'est abonné, fermer la connexion
    if (this.subscribers.size === 0 && this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
      this.connected = false
    }
  }

  /**
   * Envoyer une commande au Raspberry Pi via le serveur Rails
   * @param {number} cabineId - ID de la cabine
   * @param {string} command - Nom de la commande
   * @param {any} payload - Données de la commande
   */
  sendCommand(cabineId, command, payload) {
    if (!this.subscription) {
      console.error('[OperationalStatusChannel] Pas de connexion active pour envoyer la commande')
      return false
    }

    this.subscription.perform('send_command', {
      cabine_id: cabineId,
      command: command,
      payload: payload
    })
    return true
  }

  /**
   * Vérifie si le channel est connecté
   * @returns {boolean}
   */
  isConnected() {
    return this.connected
  }

  // Créer la subscription Action Cable (privée)
  _createSubscription() {
    const manager = this

    this.subscription = consumer.subscriptions.create("OperationalStatusChannel", {
      connected() {
        manager.connected = true
        console.log('[OperationalStatusChannel] Connecté')
      },

      disconnected() {
        manager.connected = false
        console.log('[OperationalStatusChannel] Déconnecté')
      },

      received(data) {
        console.log('[OperationalStatusChannel] Données reçues:', data)
        console.log('[OperationalStatusChannel] Subscribers actuels:', [...manager.subscribers.keys()])
        
        // Dispatcher les données au bon callback selon cabine_id
        const cabineId = Number(data.cabine_id)
        const callback = manager.subscribers.get(cabineId)

        console.log('[OperationalStatusChannel] cabineId:', cabineId, 'callback trouvé:', !!callback)

        if (callback) {
          console.log('[OperationalStatusChannel] Appel du callback pour cabine', cabineId)
          callback(data)
        } else {
          console.warn('[OperationalStatusChannel] Pas de callback pour cabine', cabineId)
        }
      }
    })
  }
}

// Export d'une instance singleton
const operationalStatusChannel = new OperationalStatusChannelManager()
export default operationalStatusChannel
